import * as React  from "react";
import { useState, useEffect} from "react";
import axios from "axios";
import Select from 'react-select';
import LoadingOverlay from 'react-loading-overlay';
import ReactPaginate from 'react-paginate';
import {getCsrfToken} from '../../commons/authenticityToken';

const PER_PAGE = 20;

const INDUSTRY_KBN_LABELS = { 0: '運営会社', 1: '保険薬局', 2: '医療機関' };
const INDUSTRY_KBN_OPTIONS = [
  { value: 0, label: '運営会社' },
  { value: 1, label: '保険薬局' },
  { value: 2, label: '医療機関' },
];

const Index = (props) => {
  axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();
  const [companies, setCompanies] = useState([]);

  //削除時の企業情報
  const [deleteCompany, setDeleteCompany] = useState({id: 0, company_name: ""});

  //削除時の証明書情報
  const [deleteCertificate, setDeleteCertificate] = useState({id: 0, company_name: "", d_certificate_file_id: 0, is_certificate_deletion_alert: false});

  // 検索内容
  const [searchName, setSearchName] = useState("");
  const [searchIndustryKbns, setSearchIndustryKbns] = useState([]);

  // ページネーション
  const [startCount, setStartCount] = useState(0);
  const [endCount, setEndCount] = useState(startCount + PER_PAGE);
  const [currentPage, setCurrentPage] = useState(0);

  // メッセージ系
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // ロード系
  const [isLoading, setIsLoading]  = useState<Boolean>(true);

  // 初期ロード
  useEffect(() =>{
    searchCompanies();
  }, []);

  // 開始位置がかわったとき
  useEffect(() =>{
    setEndCount(startCount + PER_PAGE);
  }, [startCount])

  // 企業削除モーダル
  useEffect(() =>{
    if (deleteCompany.id != 0){
      document.getElementById("open_delete_modal").click();
    }
  }, [deleteCompany])

  // 証明書削除モーダル
  useEffect(() =>{
    if (deleteCertificate.id != 0){
      document.getElementById("open_certificate_delete_modal").click();
    }
  }, [deleteCertificate])

  const onChangePage = (value) => {
    setStartCount(value['selected'] * PER_PAGE);
    setCurrentPage(value['selected'])
  }

  function initStates() {
    setIsLoading(true);
    setSuccessMessage("");
    setErrorMessage("");
    setStartCount(0);
    setCurrentPage(0);
  }

  // 検索
  function searchCompanies() {
    initStates();
    axios.get(
      '/api/internal/companies/search_companies', { params: { name: searchName, industry_kbns: searchIndustryKbns }})
      .then(function (response) {
        setCompanies(response.data.m_companies);
        setIsLoading(false);
      })
      .catch(error => {
        setErrorMessage(error.response.data.message);
        
    });
    window.scrollTo({left: 0, top: 0, behavior: "smooth"});
  }

  // 証明書削除
  function deleteCertificateSubmit(){
    initStates();
    axios.delete(
      '/api/internal/certificates/destroy', { data: { id: deleteCertificate.d_certificate_file_id }})
      .then(function (response) {
        setSuccessMessage(response.data.message);
        setCompanies((prevCompanies) => 
          prevCompanies.map((company) => (company.id == response.data.m_company_id ?  {...company, d_certificate_file_id: null} : company)));
        })
      .catch(error => {
        setErrorMessage(error.response.data.message);
      }).finally(() => {
        resetDeleteCertificate();
        window.scrollTo({left: 0, top: 0, behavior: "smooth"});
        setIsLoading(false);
      });
    
  }

  // 企業削除
  function deleteSubmit(){
    initStates();
    axios.delete(
      '/api/internal/companies/destroy', { data: { id: deleteCompany.id }})
      .then(function (response) {
        setCompanies(
          companies.filter(function(company){
            return company.id !== deleteCompany.id
        }));
        setSuccessMessage(response.data.message);
      })
      .catch(error => {
        setErrorMessage(error.response.data.message);

      }).finally(() => {
        resetDeleteCompany();
        window.scrollTo({left: 0, top: 0, behavior: "smooth"});
        setIsLoading(false);
      });
    
  }

  // 証明書削除リセット
  function resetDeleteCertificate(){
    setDeleteCertificate({id: 0, company_name: "", d_certificate_file_id: 0, is_certificate_deletion_alert: false});
  }

  function resetDeleteCompany(){
    setDeleteCompany({id: 0, company_name: ""});
  }

  return (
    <LoadingOverlay active={isLoading} spinner text="Loading...">
      { successMessage &&
        <div className="alert fade in alert-success ">
          <button type="button" className="close" data-dismiss="alert">×</button>
          {successMessage}
        </div>
      }

      { errorMessage && 
        <div className="alert alert-danger alert-dismissible" role="alert">
          <button type="button" className="close" data-dismiss="alert" aria-label="閉じる"><span aria-hidden="true">×</span></button>
            {errorMessage}
          </div>
      }
      <h3>企業一覧</h3>
      <div className="row">
        <div className="col-sm-10"/>
        <div className="col-sm-2">
          <a href="/company_group/index" className="mb20 btn btn-primary">企業グループ</a>
        </div>
      </div>

      {/* 検索エリア */}
      <div id="patient_search_area" className="panel panel-success">
        <div className="panel-heading">検索エリア</div>
          <div className="panel-body">
              <div className="row">
                <div className="form-group col-md-7 col-xs-12">
                  <label >企業名・企業コード</label>
                  <input 
                    type="text"
                    name="search_name" 
                    id="search_name" 
                    className="form-control col-lg-1" 
                    placeholder="検索したい内容を入力してください"
                    onChange={(e) => setSearchName(e.target.value)}
                  />
                </div>
              </div>
              <div className="row">
                <div className="form-group col-md-5 col-xs-12">
                  <label>企業区分</label>
                  <Select
                    isMulti
                    onChange={(values) => setSearchIndustryKbns(values.map(v => v.value))}
                    options={INDUSTRY_KBN_OPTIONS}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="選択してください"
                  />
                </div>
              </div>
              <div className="row">
                <div className="form-group col-md-offset-10 col-md-2 col-xs-12 text-right">
                  <input type="submit" name="button_search" value="検索" className="btn btn-lg btn-primary" data-disable-with="検索" onClick={() => searchCompanies()}/>
                </div>
              </div>
          </div> 
      </div>
      {/* 表示エリア */}
      <div className="table-responsive">
        <table id="notice_table" className="table table-bordered">
          <thead>
          <tr className="success">
              <th scope="col" className="text-center col-md-1">id</th>
              <th scope="col" className="text-center col-md-2">企業コード</th>
              <th scope="col" className="text-center col-md-6">企業名</th>
              <th scope="col" className="text-center col-md-2">企業区分</th>
              <th scope="col" colSpan={4}  className="text-center col-md-3"/>
          </tr>
          </thead>
          <tbody>
            { companies.slice(startCount, endCount).map((company) => { 
              return(
                <tr>
                  <td className="text-center va_middle">{company.id}</td>
                  <td className="va_middle">{company.gcs_company_code}</td>
                  <td className="va_middle">{company.company_name}</td>
                  <td className="va_middle">{INDUSTRY_KBN_LABELS[company.industry_kbn]}</td>
                  <td>
                    <button className="btn btn-warning" onClick={ ()=> location.href=`/tickets/data/purchase?company_id=${company.id}`}>チケット購入</button>
                  </td>
                  <td>
                    <button className="btn btn-primary" onClick={ ()=> location.href=`/company/${company.id}/edit`}>編集</button>
                  </td>
                  <td>
                    { company.d_certificate_file_id && (
                      <>
                        {!props.is_gcs_reader && <input id="open_certificate_delete_modal" type="hidden" data-toggle="modal" data-target="#certificate_delete_modal"/>}
                        <button disabled={props.is_gcs_reader} className="btn btn-danger" onClick={ () => setDeleteCertificate(company)}>証明書削除</button>
                      </>
                      )}
                  </td>
                  <td>
                    {!props.is_gcs_reader && <input id="open_delete_modal" type="hidden" data-toggle="modal" data-target="#company_delete_modal"/>}
                    <button disabled={props.is_gcs_reader} className="btn btn-danger" onClick={ () => setDeleteCompany(company)}>削除</button>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      {/* 削除確認モーダル */}
      <div className="modal fade" data-backdrop="static" id="company_delete_modal">
        <div className="sw-modal-content">
        <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
          <div className="sw-modal-icon-question sw-modal-icon">?</div>
          <h2>削除します</h2>
          <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
          以下の企業情報を削除します。<br />
          よろしいですか？<br />
          【{deleteCompany && deleteCompany.company_name}】<br/>
          </div>
          <a type="button"
              className="sw-modal-btn"
              style={{ backgroundColor: 'red', textDecoration: 'none'}}
              data-dismiss="modal"
              onClick={() => deleteSubmit() }
          >
          削除する
          </a>
          <button type="button" className="sw-modal-btn" data-dismiss="modal" onClick={() => resetDeleteCompany()}>キャンセル</button>
        </div>
        </div>
      </div>

      {/* 証明書確認モーダル */}
      <div className="modal fade" data-backdrop="static" id="certificate_delete_modal">
        <div className="sw-modal-content">
        <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
          <div className="sw-modal-icon-question sw-modal-icon">?</div>
          <h2>削除します</h2>
          <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
            { deleteCertificate.is_certificate_deletion_alert && <div className="red bold">すでに案内メールを送信済みです。</div> }
            以下の企業の証明書を削除します。<br />
            よろしいですか？<br />
            【{deleteCertificate && deleteCertificate.company_name}】<br/>
          </div>
          <a type="button"
              className="sw-modal-btn"
              style={{ backgroundColor: 'red', textDecoration: 'none'}}
              data-dismiss="modal"
              onClick={() => deleteCertificateSubmit() }
          >
          削除する
          </a>
          <button type="button" className="sw-modal-btn" data-dismiss="modal" onClick={() => resetDeleteCertificate()}>キャンセル</button>
        </div>
        </div>
      </div>

      <div className="text-center">
        <ReactPaginate
          pageCount={Math.ceil(companies.length / PER_PAGE)} 
          marginPagesDisplayed={1}
          pageRangeDisplayed={5} 
          onPageChange={onChangePage} 
          containerClassName='pagination'
          pageClassName='page-item'
          pageLinkClassName='page-link'
          activeClassName='active'
          previousLabel='前'
          nextLabel='次'
          previousClassName='page-item'
          nextClassName='page-item'
          previousLinkClassName='page-link'
          nextLinkClassName='page-link'
          disabledClassName='disabled'
          breakLabel='...' 
          breakClassName='page-item'
          breakLinkClassName='page-link'
          forcePage={currentPage}
        />
      </div>

      <div className="actions mt40 text-center va_middle">
        <button disabled={props.is_gcs_reader} className="btn btn-primary" onClick={ ()=> location.href=`/company/new`}>企業登録</button>
      </div>


    </LoadingOverlay>
  )
}

export default Index
